import { render, staticRenderFns } from "./ComponentModule.vue?vue&type=template&id=77b8e40f"
import script from "./ComponentModule.vue?vue&type=script&lang=js"
export * from "./ComponentModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports